import { render, staticRenderFns } from "./dispatchCustomize.vue?vue&type=template&id=011e33b0"
import script from "./dispatchCustomize.vue?vue&type=script&lang=js"
export * from "./dispatchCustomize.vue?vue&type=script&lang=js"
import style0 from "./dispatchCustomize.vue?vue&type=style&index=0&id=011e33b0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports